// 浏览器端屏蔽 node:fs/promises 等内置模块（langsmith 等依赖残留引用，实际不调用）。
const unavailable = name => async () => { throw new Error(`node:${name} is not available in the browser`); };
export const readFile = unavailable('fs.readFile');
export const writeFile = unavailable('fs.writeFile');
export const mkdir = unavailable('fs.mkdir');
export const stat = unavailable('fs.stat');
export const realpath = unavailable('fs.realpath');
export const unlink = unavailable('fs.unlink');
export const rename = unavailable('fs.rename');
export const readdir = unavailable('fs.readdir');
export const promises = { readFile, writeFile, mkdir, stat, realpath, unlink, rename, readdir };
export default { readFile, writeFile, mkdir, stat, realpath, unlink, rename, readdir, promises };
